module.exports = __webpack_public_path__ + "static/media/user-icon.9318a878.png";